<script setup lang="ts">
import './assets/style.scss'

defineProps({
  isOptional: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="v-transform-marker" :class="{ 'v-transform-marker_optional': isOptional }"></div>
</template>
